import { getDeviceIcon } from '@hotjar/webapp/utils/icons';
import { Icon, Tooltip } from '@hotjar/hotsauce';
import type { Device } from '@hotjar/feedback/domain/common/Responses/Device';
import { useTranslation } from '@hotjar/translations';

export function DeviceDetails(props: { device: Device; x: number; y: number }): JSX.Element {
  const { device, x, y } = props;
  const { t } = useTranslation('feedback', { keyPrefix: 'common.responses-list' });

  const deviceText = t('device-details', { x, y, device });

  return (
    <Tooltip text={deviceText}>
      <Icon description={deviceText} icon={getDeviceIcon(device)} />
    </Tooltip>
  );
}
